import { Box, Typography, CssBaseline, ThemeProvider, useTheme, Card, CardContent, Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglassEnd } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../routes/routes";
import { useAppDispatch } from "../../common/state/hooks";
import { update } from "../../common/state/Slices/HeaderMenuSlice";
import { useEffect } from "react";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import styles from "./ComingSoon.module.css";

export const ComingSoon = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const handleNavigation = () => {
        dispatch(
            update({
                selectedMenu: Routes.HOME
            })
        )
        navigate(Routes.HOME);
    };

    useEffect(() => {
        dispatch(
            update(
                { 
                    selectedMenu: Routes.KNOWLEDGE_BASE
                }
            )
        );
    }, [dispatch]);

    return (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box className={styles.container}>
            <Card className={styles.card}>
                <CardContent>
                    <FontAwesomeIcon className={styles.icon} icon={faHourglassEnd} />
                    <Typography
                        variant="h1"
                        color="#454545"
                        className={styles.mainText}
                    >
                        Coming Soon
                    </Typography>
                    <Typography
                        variant="body2"
                        color="#454545"
                        className={styles.secondaryText}
                    >
                        We're working hard to bring you an amazing experience. Stay tuned for updates!
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<FontAwesomeIcon icon={faHome} />}
                        className={styles.homeButton}
                        onClick={handleNavigation}
                    >
                        Back to Home
                    </Button>
                </CardContent>
            </Card>
        </Box>
    </ThemeProvider>
    );
};